import { useEffect } from 'react';
import sw from '@uswitch/ev-utils/switch';
export var useConsent = function useConsent(_ref) {
  var _ref$consentApiName = _ref.consentApiName,
      consentApiName = _ref$consentApiName === void 0 ? 'not-defined' : _ref$consentApiName,
      method = _ref.method;

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return useEffect(function () {
    sw({
      uconsent: function uconsent() {
        return import('./uconsent').then(function (m) {
          return m.uConsent.apply(m, [method].concat(args));
        });
      },
      rvuconsent: "doesn't exist yet",
      'not-defined': 'No consent type given',
      default: 'consent type does not exist in ev'
    })(consentApiName);
  });
};
//# sourceMappingURL=index.js.map